var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_vm._m(0),_vm._m(1),_c('button',{staticClass:"submit",on:{"click":function($event){return _vm.submit()}}},[_vm._v("返回"+_vm._s(_vm.count))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":require("@/assets/img/成功.png")}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("注册成功")]),_c('p',[_vm._v("恭喜您,完成法人注册")])])
}]

export { render, staticRenderFns }